/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-07-01 21:23:52
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 15:04:56
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCurrency/service/index.tsx
 */
import {
  currencies,
  getSalesChannelCurrency,
  getSymbol,
  saveSalesChannelCurrency,
} from '@/src/request/currency';
import { msg } from '@/src/tools/message';
import lodash from 'lodash';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { modal } from 'src/utils/Modal';
import {
  Cnversion,
  TruncateRule,
  conversionOptions,
  DisplayFormat,
  SalesChannelCurrencyConfig,
  SalesChannelCurrencyItem,
} from '../constant';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { get } from 'lodash';
import { UPDATE_GLOBAL_CONFIG_SCS } from 'src/tools/constant';
import { randomNumber } from 'src/tools/helper';
import emit from 'src/tools/event';
function useService(permissions) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const history = useHistory();
  const params: Record<string, any> = useParams();
  const { view_currency_setting } = permissions(params.uuid);

  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [secondCuSymbol, setSecondary] = useState<Array<string>>([]);
  const [copy, setCopy] = useState<SalesChannelCurrencyConfig | null>(null);
  const [currencyConfig, setCurrencyConfig] =
    useState<SalesChannelCurrencyConfig>([]);
  const [primaryCurrencyConfig, setPrimaryCurrencyConfig] = useState<
    SalesChannelCurrencyItem | undefined
  >(undefined);

  const nonEditable = get(primaryCurrencyConfig, 'editable') === false;
  useEffect(() => {
    if (view_currency_setting) {
      inner_initCurrencyConfig();
    }
  }, []);

  const navigateBack = () => {
    history.push(`/salesChannel/settings/${params.uuid}`);
  };

  const handleDiscard = () => {
    history.push(`/salesChannel/settings/${params.uuid}`);
  };

  const handleSubmit = () => {
    // API要求roundingRule和truncateRule要根据conversionMode来决定是否为空
    const _currencyConfig = (currencyConfig || []).map((item) => {
      const { referenceConversionMode, conversionMode } = item;
      return {
        ...item,
        referenceRoundingRule:
          referenceConversionMode === Cnversion.Truncate
            ? null
            : item.referenceRoundingRule ?? TruncateRule.HUNDREDTHS,
        referenceTruncateRule:
          referenceConversionMode === Cnversion.Round
            ? null
            : item.referenceTruncateRule ?? TruncateRule.HUNDREDTHS,
        roundingRule:
          conversionMode === Cnversion.Truncate
            ? null
            : item.roundingRule ?? TruncateRule.HUNDREDTHS,
        truncateRule:
          conversionMode === Cnversion.Round
            ? null
            : item.truncateRule ?? TruncateRule.HUNDREDTHS,
      };
    });
    saveSalesChannelCurrency(_currencyConfig).then((res: any[]) => {
      const symbolMap = new Map(
        (currencyConfig || []).map((item) => [
          item.currencyCode,
          item.currencySymbolList,
        ]),
      );
      const merged = (res || []).map((item: any) => ({
        ...item,
        currencySymbolList: symbolMap.get(item.currencyCode) || [],
      }));
      setCopy(merged);
      setCurrencyConfig(merged);
      msg.success(getI18n('general.savesuccess'));
      emit.emit(UPDATE_GLOBAL_CONFIG_SCS);
    });
  };

  function createDefaultCurrencyItem(
    value: { value: string; label: string },
    isPrimary: boolean,
    salesChannelUuid: string,
    currencySymbolList: string[] = [],
  ): SalesChannelCurrencyItem {
    return {
      uuid: randomNumber(),
      currencyCode: value.value,
      currencyName: value.label,
      showSecondary: false,
      decimalPosition: 2,
      conversionMode: Cnversion.Truncate,
      truncateRule: TruncateRule.HUNDREDTHS,
      roundingRule: TruncateRule.HUNDREDTHS,
      decimalSeparator: 'POINT',
      thousandsSeparator: 'NOT_USE',
      currencySymbol: currencySymbolList[0] || '',
      currencySymbolList: currencySymbolList,
      currencyDisplayFormat: 'PREFIX_AMOUNT',
      primary: isPrimary,
      salesChannelUuid,
      deleted: false,
      referenceDecimalPosition: 2,
      referenceConversionMode: Cnversion.Truncate,
      referenceRoundingRule: TruncateRule.HUNDREDTHS,
      referenceTruncateRule: TruncateRule.HUNDREDTHS,
      referenceDecimalSeparator: 'POINT',
      referenceThousandsSeparator: 'NOT_USE',
    };
  }

  // 切换Primary Currency
  const handleChangeCurrency = async (value: {
    value: string;
    label: string;
  }) => {
    const existingCurrency = currencyConfig.find(
      (c) => c.currencyCode === value.value,
    );
    let currencySymbolList: string[] = [];
    if (!existingCurrency) {
      try {
        const res = await getSymbol(value.value);
        currencySymbolList = Array.isArray(res) ? res : [];
      } catch (e) {
        console.error('getSymbol error:', e);
      }
    }

    const updatePrimaryCurrency = () => {
      setCurrencyConfig((prev) => {
        const updated = prev.map((c) => {
          if (c.primary) {
            return { ...c, primary: false, deleted: true };
          }
          return { ...c, primary: false };
        });
        if (existingCurrency) {
          return updated.map((c) =>
            c.currencyCode === value.value
              ? { ...c, primary: true, deleted: false }
              : c,
          );
        } else {
          return [
            ...updated,
            createDefaultCurrencyItem(
              value,
              true,
              params.uuid,
              currencySymbolList,
            ),
          ];
        }
      });

      setPrimaryCurrencyConfig(
        createDefaultCurrencyItem(value, true, params.uuid, currencySymbolList),
      );
    };

    if (
      currencyConfig.some((c) => c.primary) &&
      existingCurrency &&
      existingCurrency.secondaryCurrencyCode === value.value
    ) {
      modal.info({
        title: getI18n('salesChannelCurrency.index.changePrimaryCurrency'),
        content: (
          <>
            <div>
              {getI18n('salesChannelCurrency.index.changePrimaryCurrencyTip1')}
            </div>
            <div>
              {getI18n('salesChannelCurrency.index.changePrimaryCurrencyTip2')}
            </div>
            <div style={{ marginTop: '15px' }}>
              {getI18n('salesChannelCurrency.index.changePrimaryCurrencyTip3')}
            </div>
          </>
        ),
        onOkText: getI18n('general.confirm'),
        onCancelText: getI18n('general.cancel'),
        onOk: updatePrimaryCurrency,
        onCancel: () => console.log('cancel'),
      });
    } else {
      modal.info({
        title: getI18n('salesChannelCurrency.index.changePrimaryCurrency'),
        content: (
          <>
            <div>
              {getI18n('salesChannelCurrency.index.changePrimaryCurrencyTip1')}
            </div>
            <div>
              {getI18n('salesChannelCurrency.index.changePrimaryCurrencyTip3')}
            </div>
          </>
        ),
        onOkText: getI18n('general.confirm'),
        onCancelText: getI18n('general.cancel'),
        onOk: updatePrimaryCurrency,
        onCancel: () => console.log('cancel'),
      });
    }
  };

  const handleChangeSecondCurrency = async (value: {
    value: string;
    label: string;
  }) => {
    const { value: currencyCode, label: currencyName } = value;
    setCurrencyConfig((prev) =>
      prev.map((item) =>
        item.primary
          ? {
              ...item,
              secondaryCurrencyCode: currencyCode,
              secondaryCurrencyName: currencyName,
            }
          : item,
      ),
    );

    setPrimaryCurrencyConfig((prev) =>
      prev
        ? {
            ...prev,
            secondaryCurrencyCode: currencyCode,
            secondaryCurrencyName: currencyName,
          }
        : null,
    );
    try {
      const res = await getSymbol(currencyCode);
      if (!Array.isArray(res)) return;

      const config = inner_updateConfig();

      setSecondary(res);

      setCurrencyConfig((prevConfig) =>
        prevConfig.map((item) =>
          item.primary
            ? {
                ...item,
                secondaryCurrencyDisplayFormat: DisplayFormat.PREFIX_AMOUNT,
                secondaryCurrencySymbol:
                  res && Array.isArray(res) ? res[0] : undefined,
                referenceDecimalPosition: 2,
                referenceConversionMode: Cnversion.Truncate,
                referenceRoundingRule: TruncateRule.HUNDREDTHS,
                referenceTruncateRule: TruncateRule.HUNDREDTHS,
                referenceDecimalSeparator: 'POINT',
                referenceThousandsSeparator: 'NOT_USE',
              }
            : item,
        ),
      );

      setPrimaryCurrencyConfig({
        ...config,
        secondaryCurrencyDisplayFormat: DisplayFormat.PREFIX_AMOUNT,
        secondaryCurrencySymbol: res && Array.isArray(res) ? res[0] : undefined,
        secondaryCurrencyCode: currencyCode,
        secondaryCurrencyName: currencyName,
        referenceDecimalPosition: 2,
        referenceConversionMode: Cnversion.Truncate,
        referenceRoundingRule: TruncateRule.HUNDREDTHS,
        referenceTruncateRule: TruncateRule.HUNDREDTHS,
        referenceDecimalSeparator: 'POINT',
        referenceThousandsSeparator: 'NOT_USE',
      });
    } catch (error) {
      console.error('Error in handleChangeSecondaryCurrency:', error);
    }
  };

  const handleChangeShowSecond = (show: boolean) => {
    setCurrencyConfig((prev) =>
      prev.map((item) =>
        item.primary
          ? {
              ...item,
              showSecondary: show,
              secondaryCurrencyCode: show ? item.secondaryCurrencyCode : null,
              secondaryCurrencyName: show ? item.secondaryCurrencyName : null,
              secondaryCurrencyDisplayFormat: show
                ? item.secondaryCurrencyDisplayFormat
                : null,
              secondaryCurrencySymbol: show
                ? item.secondaryCurrencySymbol
                : null,
            }
          : item,
      ),
    );
    setPrimaryCurrencyConfig({
      ...primaryCurrencyConfig,
      showSecondary: show,
      secondaryCurrencyCode: show
        ? primaryCurrencyConfig.secondaryCurrencyCode
        : null,
      secondaryCurrencyName: show
        ? primaryCurrencyConfig.secondaryCurrencyName
        : null,
      secondaryCurrencyDisplayFormat: show
        ? primaryCurrencyConfig.secondaryCurrencyDisplayFormat
        : null,
      secondaryCurrencySymbol: show
        ? primaryCurrencyConfig.secondaryCurrencySymbol
        : null,
    });
  };

  const handleChangeDecimalPosition = (
    uuid: string,
    decimalPosition: number,
    isReferenceCurrency = false,
  ) => {
    const _handleOnGetAmount = (rule): number => {
      const arr = conversionOptions({ getI18n });
      const o = arr.find((i) => rule === get(i, 'value'));
      return get(o, 'index');
    };

    const _handleOnGetValue = (index): any => {
      const arr = conversionOptions({ getI18n });
      const o = arr.find((i) => index === get(i, 'index'));
      return get(o, 'value');
    };

    setCurrencyConfig((prevConfig) =>
      prevConfig.map((item) => {
        if (item.uuid !== uuid) return item;

        if (isReferenceCurrency) {
          const newItem = {
            ...item,
            referenceDecimalPosition: decimalPosition,
          };

          const { referenceRoundingRule, referenceTruncateRule } = item;

          if (referenceRoundingRule) {
            const index = _handleOnGetAmount(referenceRoundingRule);
            if (index > decimalPosition + 1) {
              const max = decimalPosition + 1;
              newItem.referenceRoundingRule = _handleOnGetValue(max);
            }
          }

          if (referenceTruncateRule) {
            const index = _handleOnGetAmount(referenceTruncateRule);
            if (index > decimalPosition + 1) {
              const max = decimalPosition + 1;
              newItem.referenceTruncateRule = _handleOnGetValue(max);
            }
          }
          setPrimaryCurrencyConfig(newItem);

          return newItem;
        } else {
          const newItem = {
            ...item,
            decimalPosition,
          };

          const { roundingRule, truncateRule } = item;

          if (roundingRule) {
            const index = _handleOnGetAmount(roundingRule);
            if (index > decimalPosition + 1) {
              const max = decimalPosition + 1;
              newItem.roundingRule = _handleOnGetValue(max);
            }
          }

          if (truncateRule) {
            const index = _handleOnGetAmount(truncateRule);
            if (index > decimalPosition + 1) {
              const max = decimalPosition + 1;
              newItem.truncateRule = _handleOnGetValue(max);
            }
          }

          return newItem;
        }
      }),
    );
  };

  const handleChangePropsViaEvent = (
    uuid: string,
    prop: string,
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    isReferenceCurrency = false,
  ) => {
    const value = e.target.value;

    setCurrencyConfig((prevConfig) =>
      prevConfig.map((item) =>
        item.uuid === uuid ? { ...item, [prop]: value } : item,
      ),
    );
    if (isReferenceCurrency) {
      setPrimaryCurrencyConfig({ ...primaryCurrencyConfig, [prop]: value });
    }
  };

  const handleChangePropsViaValue = (
    uuid: string,
    prop: string,
    value: any,
    isReferenceCurrency = false,
  ) => {
    console.log(uuid, prop, value, isReferenceCurrency);

    setCurrencyConfig((prevConfig) =>
      prevConfig.map((item) =>
        item.uuid === uuid ? { ...item, [prop]: value } : item,
      ),
    );
    if (isReferenceCurrency) {
      setPrimaryCurrencyConfig({ ...primaryCurrencyConfig, [prop]: value });
    }
  };

  const primaryCurrency = currencyConfig.find((item) => item.primary);
  const getOptions = (isPrimary: boolean) => {
    return isPrimary
      ? currencyOptions
      : currencyOptions.filter((c) => c.code !== primaryCurrency?.currencyCode);
  };

  const inner_initCurrencyConfig = async () => {
    const currencyOptions: any = await currencies();
    const config: any = await getSalesChannelCurrency(params.uuid);
    const reportingCurrency = Array.isArray(currencyOptions)
      ? currencyOptions?.filter((c) => c.reportingCurrency)[0]
      : {};
    const filledConfig = await inner_fillConfig(config, reportingCurrency);

    setCurrencyConfig(filledConfig);

    const primary = config.find((item) => item.primary === true);
    if (primary) {
      setPrimaryCurrencyConfig(primary);
      if (primary.secondaryCurrencyCode) {
        try {
          const res = await getSymbol(primary.secondaryCurrencyCode);
          if (Array.isArray(res)) {
            setSecondary(res);
          } else {
            setSecondary([]);
          }
        } catch (e) {
          setSecondary([]);
        }
      }
    }
    setCurrencyOptions(currencyOptions);
    //查看是否存在改动
    setCopy(filledConfig);
  };
  const inner_fillConfig = async (
    config: SalesChannelCurrencyConfig,
    reportingCurrency: any,
  ): Promise<SalesChannelCurrencyConfig> => {
    const baseConfig: SalesChannelCurrencyConfig =
      Array.isArray(config) && config.length
        ? config
        : [
            {
              currencyCode: reportingCurrency.code,
              currencyName: `${reportingCurrency.label} - ${getI18n(
                'salesChannelCurrency.index.reportingcurrency',
              )}`,
              showSecondary: false,
              decimalPosition: 2,
              decimalSeparator: 'POINT',
              thousandsSeparator: 'NOT_USE',
              currencySymbol: undefined,
              currencyDisplayFormat: 'PREFIX_AMOUNT',
              salesChannelUuid: params.uuid,
              deleted: false,
            },
          ];

    const updatedConfig = await Promise.all(
      baseConfig.map(async (item) => {
        let currencySymbolList: string[] = [];
        try {
          const res = await getSymbol(item.currencyCode);
          currencySymbolList = Array.isArray(res) ? res : [];
        } catch (e) {
          console.error(`getSymbol error for ${item.currencyCode}:`, e);
        }

        return {
          ...item,
          currencySymbolList,
        };
      }),
    );

    return updatedConfig;
  };

  const inner_updateConfig = () => {
    const reportingCurrency = Array.isArray(currencyOptions)
      ? currencyOptions?.filter((c) => c.reportingCurrency)[0]
      : {};
    //drop down中的位数默认选中与decimal place 配置的一致 e.g. decimal place设置数字为2，round number down to “ Hundredths (2 decimals, cents)”
    if (
      reportingCurrency &&
      reportingCurrency.code &&
      (reportingCurrency.code !== primaryCurrencyConfig.secondaryCurrencyCode ||
        reportingCurrency.code !== primaryCurrencyConfig?.currencyCode)
    ) {
      return {
        ...primaryCurrencyConfig,
        conversionMode: primaryCurrencyConfig.conversionMode
          ? primaryCurrencyConfig.conversionMode
          : Cnversion.Round,
        roundingRule:
          primaryCurrencyConfig.conversionMode === Cnversion.Round ||
          !primaryCurrencyConfig.conversionMode
            ? primaryCurrencyConfig.roundingRule
              ? primaryCurrencyConfig.roundingRule
              : conversionOptions({ getI18n }).find(
                  (c) => c.index === primaryCurrencyConfig.decimalPosition + 1,
                ).value
            : null,
      };
    } else {
      return primaryCurrencyConfig;
    }
  };

  const handleOnAddOtherCurrency = async (value: {
    value: string;
    label: string;
    key: string;
  }) => {
    const existingIndex = currencyConfig.findIndex(
      (item) => item.currencyCode === value.value,
    );

    if (existingIndex !== -1) {
      setCurrencyConfig((prev) => {
        const updated = [...prev];
        updated[existingIndex] = {
          ...updated[existingIndex],
          deleted: false,
        };
        return updated;
      });
      return;
    }

    let currencySymbolList: string[] = [];

    await getSymbol(value.value).then((res: Array<string>) => {
      if (!res || res.length === 0) return;
      currencySymbolList = res;
    });

    const newCurrencyItem = createDefaultCurrencyItem(
      value,
      false,
      params.uuid,
      currencySymbolList,
    );

    setCurrencyConfig((prev) => [...prev, newCurrencyItem]);
  };

  const handleOnDeleteOtherCurrency = (uuid: string) => {
    setCurrencyConfig((prev) =>
      prev.map((item) =>
        item.uuid === uuid ? { ...item, deleted: true } : item,
      ),
    );
  };

  const handleOnFetchSymbol = (value: {
    value: string;
    label: string;
    key: string;
  }) => {
    const currencyCode = value.value;

    const matchedItem = currencyConfig.find(
      (item) => item.currencyCode === currencyCode,
    );
    if (!matchedItem) return;

    getSymbol(currencyCode).then((res: Array<string>) => {
      if (!res || res.length === 0) return;

      const symbol = res[0];

      setCurrencyConfig((prev) =>
        prev.map((item) =>
          item.currencyCode === currencyCode
            ? {
                ...item,
                currencySymbol: symbol,
                currencySymbolList: res,
              }
            : item,
        ),
      );
    });
  };

  return {
    reportingCurrency: Array.isArray(currencyOptions)
      ? currencyOptions?.filter((c) => c.reportingCurrency)[0]
      : {},
    secondCuSymbol,
    currencyConfig,
    primaryCurrencyConfig,
    salesChannelUuid: params.uuid,
    saveDisabled: !copy || lodash.isEqual(copy, currencyConfig),
    getOptions,
    navigateBack,
    handleSubmit,
    handleDiscard,
    handleChangeCurrency,
    handleChangeShowSecond,
    handleChangeSecondCurrency,
    handleChangeDecimalPosition,
    handleChangePropsViaEvent,
    handleChangePropsViaValue,
    handleOnAddOtherCurrency,
    handleOnDeleteOtherCurrency,
    handleOnFetchSymbol,
    nonEditable,
  };
}

export default useService;
